import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import leftArrow from "Assets/newicons/arrow/chevron/left/outline/chevron-left-outline-16px.svg";
import rightArrow from "Assets/newicons/arrow/chevron/right/outline/chevron-right-outline-16px.svg";
import backArrow from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-16px.svg";
import backArrowBlue from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-blue-16px.svg";
import calendariconoutline from "Assets/newicons/user-interface/calendar/outline/calendar-outline-16px.svg";
import { DatePickerComponent } from "Component/Custom";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
// import shouldPureComponentUpdate from 'react-pure-render/function';
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import PageHeader from "Component/Headers/pageHeader";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import Configs from "Constants/Configs";
import GoogleMapReact, { fitBounds } from "google-map-react";
import moment from "moment";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { convertDateForBackend, getEJ2CalenderDateFormat } from "Utils";
import { getUserFormattedTimeFromAPIData } from "Utils/dates";
import { instance } from "../../../Actions/AxiosInstance";
import { RightDrawer } from "../../../Actions/commonAction";
import blankstate from "../../../Assets/Svg/attendance.svg";
import { getFormattedImageLink } from "../../../Utils";
import "./index.scss";
import Marker from "./Marker";
import "./Marker.scss";

const size = {
  width: 640, // Map width in pixels
  height: 380, // Map height in pixels
};

const filterby = [
  {
    displayname: "Shift",
    displayvalue: 1,
  },
  {
    displayname: "Department",
    displayvalue: 2,
  },
  {
    displayname: "Designation",
    displayvalue: 3,
  },
];

class Gps extends Component {
  // shouldComponentUpdate = shouldPureComponentUpdate;

  constructor(props) {
    super(props);
    this.state = {
      empgpslogs: [],
      empList1: [],
      department: [],
      selectedempdata: null,
      isselectedemp: false,
      selecteddepartmentid: null,
      selecteddesignationid: null,
      designation: [],
      iscalendarfiltercheck: false,
      isempgpslogs: false,
      selectedshiftdata: null,
      officelocation: [],
      isdefault: true,
      SelectedEmpData: null,
      loading: false,
      iscalendar: false,
      employeeids: null,
      lat: 19.1181078,
      lng: 72.850086,
      selectedofficelocationid: null,
      shifts: [],
      selectedfilterid: null,

      places: [],
      shiftdate: moment(new Date()).format("YYYY-MM-DD"),
    };

    this.getFilterData = this.getFilterData.bind(this);
    this.GetEmployeeGpsLogs = this.GetEmployeeGpsLogs.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.SearchEmployee = this.SearchEmployee.bind(this);
    this.UpdateSelectedEmpId = this.UpdateSelectedEmpId.bind(this);
  }

  componentDidMount() {
    this.getFilterData();
    if (this.props.AuthenticationAction.login.masterprofileid != 9) {
      this.GetEmployeeDetails();
    }
  }

  componentWillUnmount() {
    // unbind the event
  }

  getMapBounds = (map, maps, lat, lang) => {
    const bounds = new maps.LatLngBounds();
    bounds.extend(new maps.LatLng(lat, lang));
    return bounds;
  };

  // Re-center map when resizing the window
  bindResizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, "idle", () => {
      maps.event.addDomListener(window, "resize", () => {
        map.fitBounds(bounds);
      });
    });
  };

  // Fit map to its bounds after the api is loaded
  apiIsLoaded = (map, maps, lat, lang) => {
    const bounds = this.getMapBounds(map, maps, lat, lang);
    // Fit map to bounds
    map.fitBounds(bounds);
    // Bind the resize listener
    this.bindResizeListener(map, maps, bounds);
  };

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  handleChange(key, value) {
    // console.log('value: ', value);
    if (key == "selectedfilterid") {
      this.setState({
        [key]: [value],
      });
    } else if (key == "selectedshiftdata") {
      this.setState({
        [key]: [value],
        employeeids: null,
        SelectedEmpData: null,
        empgpslogs: [],
        isempgpslogs: false,
        isselectedemp: false,
        selectedempdata: null,
        selecteddepartmentid: null,
        selecteddesignationid: null,
      });
    } else if (key == "selecteddepartmentid") {
      this.setState({
        [key]: [value],
        employeeids: null,
        SelectedEmpData: null,
        empgpslogs: [],
        isempgpslogs: false,
        isselectedemp: false,
        selectedempdata: null,
        selectedshiftdata: null,
        selecteddesignationid: null,
      });
    } else if (key == "selecteddesignationid") {
      this.setState({
        [key]: [value],
        employeeids: null,
        SelectedEmpData: null,
        empgpslogs: [],
        isempgpslogs: false,
        isselectedemp: false,
        selectedempdata: null,
        selectedshiftdata: null,
        selecteddepartmentid: null,
      });
    } else if (key == "shiftdate") {
      this.setState({
        [key]: value,
        isselectedemp: false,
        selectedempdata: null,
        iscalendar: false,
      });
      if (this.state.isempgpslogs) {
        this.setState(
          {
            iscalendarfiltercheck: true,
            // isempgpslogs: false,
            empgpslogs: [],
          },
          () => this.GetEmployeeGpsLogs(),
        );
      }
    } else {
      this.setState({
        [key]: [value],
        employeeids: null,
        SelectedEmpData: null,
        empgpslogs: [],
        isempgpslogs: false,
        isselectedemp: false,
        selectedempdata: null,
      });
    }
  }

  UpdateSelectedEmpId(selectedItem) {
    this.setState({
      employeeids: selectedItem ? [selectedItem.displayvalue] : null,
      SelectedEmpData: selectedItem,

      // selecteddepartmentid: null,
      // selecteddesignationid: null,
      // selectedfilterid: null,
      // selectedshiftdata: null,
      empgpslogs: [],
      isempgpslogs: false,
      isselectedemp: false,
      selectedempdata: null,
      // selectedofficelocationid: null,
    });
  }

  GetEmployeeDetails() {
    const data = {
      featurekey: "attendanceLogs",
      workflowfortypeid: 2,
    };
    instance
      .post(`attendance/approverreportee`, data)
      .then((result) => {
        const arrAllEmp = result.data.result;
        const opt = [];
        opt.push({
          label: "Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 1,
          ),
        });

        opt.push({
          label: "In-Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 3,
          ),
        });

        this.setState({ empList1: opt });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getFilterData() {
    const URL = `attendance/initempgpslogs`;
    instance
      .get(URL)
      .then((result) => {
        this.setState({
          department: result.data.result[0].department,
          selecteddepartmentid: result.data.result[0].departmentid
            ? [result.data.result[0].departmentid]
            : null,
          designation: result.data.result[0].designation,
          officelocation: result.data.result[0].officelocation,
          selectedofficelocationid: result.data.result[0].officelocationid
            ? [result.data.result[0].officelocationid]
            : null,
          shifts: result.data.result[0].shifts,
          selectedfilterid: result.data.result[0].departmentid ? 2 : null,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
        this.setState({ CommonError });
      });
  }

  GetEmployeeGpsLogs(id) {
    let data = null;
    if (this.state.employeeids) {
      data = {
        // shiftdate: moment(new Date()).format("YYYY-MM-DD"),
        shiftdate: convertDateForBackend(this.state.shiftdate),
        officelocationids: null,
        employeeids:
          this.state.employeeids && this.state.employeeids.length > 0
            ? this.state.employeeids
            : null,
        shiftids: null,
        departmentids: null,
        designationids: null,
      };
    } else {
      data = {
        // shiftdate: moment(new Date()).format("YYYY-MM-DD"),
        shiftdate: convertDateForBackend(this.state.shiftdate),
        officelocationids:
          this.state.selectedofficelocationid &&
          this.state.selectedofficelocationid.length > 0
            ? this.state.selectedofficelocationid
            : null,
        employeeids: null,
        shiftids:
          this.state.selectedshiftdata &&
          this.state.selectedshiftdata.length > 0
            ? this.state.selectedshiftdata
            : null,
        departmentids:
          this.state.selecteddepartmentid &&
          this.state.selecteddepartmentid.length > 0
            ? this.state.selecteddepartmentid
            : null,
        designationids:
          this.state.selecteddesignationid &&
          this.state.selecteddesignationid.length > 0
            ? this.state.selecteddesignationid
            : null,
      };
    }

    const URL = "attendance/getempgpslogs";
    // if (id == 1 && !this.state.employeeids) {
    //     this.props.enqueueSnackbar("Please select employee", {
    //         variant: "error",
    //     });
    // }
    // else
    if (!this.state.employeeids && !this.state.selectedofficelocationid) {
      // this.props.enqueueSnackbar("Please select employee or office location", {
      //     variant: "error",
      // });
    } else if (
      this.state.selectedfilterid == 1 &&
      !this.state.selectedshiftdata
    ) {
      this.props.enqueueSnackbar("Please select shift", {
        variant: "error",
      });
    } else if (
      this.state.selectedfilterid == 2 &&
      !this.state.selecteddepartmentid
    ) {
      this.props.enqueueSnackbar("Please select department", {
        variant: "error",
      });
    } else if (
      this.state.selectedfilterid == 3 &&
      !this.state.selecteddesignationid
    ) {
      this.props.enqueueSnackbar("Please select designation", {
        variant: "error",
      });
    } else {
      const totalseconds = 1;
      const secondsforintervals = totalseconds * 1000;

      this.interval = setInterval(
        () =>
          this.setState({
            time: this.state.time >= 99 ? 99 : this.state.time + 1,
          }),
        secondsforintervals / 100,
      );
      this.setState(
        {
          time: 0,
          loading: true,
        },
        () => {
          instance
            .post(URL, data)
            .then((result) => {
              this.setState({
                empgpslogs: result.data.result,
                isempgpslogs:
                  result.data.result.length > 0
                    ? true
                    : this.state.isempgpslogs,
                time: 100,
                lat:
                  (result.data.result &&
                    result.data.result[0] &&
                    result.data.result[0].gpslogs &&
                    result.data.result[0].gpslogs[0] &&
                    result.data.result[0].gpslogs[0].latitude) ||
                  this.state.lat,
                lng:
                  (result.data.result &&
                    result.data.result[0] &&
                    result.data.result[0].gpslogs &&
                    result.data.result[0].gpslogs[0] &&
                    result.data.result[0].gpslogs[0].longitude) ||
                  this.state.lng,
                isdefault: false,
                loading: false,
              });
            })
            .catch((error) => {
              this.setState({
                time: 0,
                loading: false,
              });
              const CommonError = error.response
                ? error.response.data.error.message
                : error.message;
              this.props.enqueueSnackbar(CommonError, { variant: "error" });
            });
        },
      );
    }
  }

  SearchEmployee(search) {
    if (search.length < 1) return;
    if (
      (!this.state.prevSearch || this.state.prevSearch != search) &&
      search.length >= 1
    ) {
      const URL = `/subscription/employeelist`;
      const data = {
        searchfor: search,
        statusid: null,
        featurekey: "attendanceLogs",
      };
      instance
        .post(URL, data)
        .then((result) => {
          const arrAllEmp = result.data.result;
          const opt = [];
          opt.push({
            label: "Active",
            options: arrAllEmp.filter(
              (employee) => employee.employeestatusid == 1,
            ),
          });

          opt.push({
            label: "In-Active",
            options: arrAllEmp.filter(
              (employee) => employee.employeestatusid == 3,
            ),
          });

          this.setState({ empList: opt });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  render() {
    const bounds = {
      nw: {
        lat: this.state.lat,
        lng: this.state.lng,
      },
      se: {
        lat: this.state.lat,
        lng: this.state.lng,
      },
    };
    // const { center, zoom } = fitBounds(bounds, size);

    const { masterprofileid } = this.props.AuthenticationAction.login;
    return (
      <div className="content-outer-wrapper-with-tab">
        <Grid container spacing={3}>
          <Grid item md={4} sm={12}>
            <PageHeader header="GPS attendance" />
            <Paper
              className="rounded-rectangle-paper padding16 display-flex margin-bottom-16"
              style={{ justifyContent: "space-between" }}
            >
              <div>
                <p className="input-label">Select date</p>
                <DatePickerComponent
                  placeholder="Effective date"
                  allowEdit={false}
                  start="Decade"
                  format={getEJ2CalenderDateFormat()}
                  border="1px solid #166ab3 !important"
                  max={new Date()}
                  change={(e) => this.handleChange("shiftdate", e.value)}
                  value={this.state.shiftdate}
                  hideClearIcon={
                    this.state.empgpslogs.length > 0 ? true : false
                  }
                />
              </div>
              <div style={{ display: "flex", marginTop: 18 }}>
                <img
                  src={leftArrow}
                  onClick={() =>
                    this.handleChange(
                      "shiftdate",
                      moment(this.state.shiftdate).subtract(1, "d"),
                    )
                  }
                  style={{ cursor: "pointer", padding: "0 10px" }}
                />

                <img src={calendariconoutline} style={{ margin: "0 24px" }} />

                {/* {moment(this.state.shiftdate).format("YYYY-MM-DD") !=
                  moment(new Date()).format("YYYY-MM-DD") && ( */}
                <span
                  style={
                    moment(this.state.shiftdate).format("YYYY-MM-DD") !=
                    moment(new Date()).format("YYYY-MM-DD")
                      ? {
                          cursor: "pointer",

                          display: "inline-flex",
                        }
                      : {
                          cursor: "not-allowed",

                          display: "inline-flex",
                        }
                  }
                >
                  <img
                    src={rightArrow}
                    onClick={() =>
                      this.handleChange(
                        "shiftdate",
                        moment(this.state.shiftdate).add(1, "d"),
                      )
                    }
                    style={
                      moment(this.state.shiftdate).format("YYYY-MM-DD") !=
                      moment(new Date()).format("YYYY-MM-DD")
                        ? {
                            cursor: "pointer",
                            padding: "0 10px",
                          }
                        : {
                            pointerEvents: "none",
                            padding: "0 10px",
                            opacity: 0.4,
                          }
                    }
                  />
                </span>
                {/* )} */}
              </div>
              {/* <span style={{ marginLeft: 24, marginTop: 8 }} >{getFormattedDate(this.state.shiftdate)}</span> */}
            </Paper>
            {(!this.state.isempgpslogs ||
              (!this.state.iscalendarfiltercheck &&
                this.state.isempgpslogs &&
                this.state.empgpslogs.length == 0)) && (
              <Paper
                className="rounded-rectangle-paper padding16 thin-scroll"
                style={{
                  // height: "65vh",
                  height: "calc(100vh - 350px)",
                  overflowY: "auto",
                }}
              >
                <div>
                  <p className="input-label">Select employee</p>
                  {masterprofileid == 9 ? (
                    <Select
                      // className="selectsearch inlindClass width360"
                      onChange={this.UpdateSelectedEmpId}
                      onInputChange={this.SearchEmployee}
                      options={this.state.empList}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      value={this.state.SelectedEmpData}
                      placeholder="Search Employee"
                      isClearable={true}
                    />
                  ) : (
                    this.state.empList1 &&
                    this.state.empList1.length > 0 && (
                      <Select
                        className="selectsearch width250"
                        onChange={this.UpdateSelectedEmpId.bind(this)}
                        options={this.state.empList1}
                        getOptionLabel={(option) => option.displayname}
                        getOptionValue={(option) => option.displayvalue}
                        value={this.state.SelectedEmpData}
                        placeholder="Select Employee"
                      />
                    )
                  )}

                  {/* <div style={{ marginTop: 16, marginLeft: 60 }}>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            className="btn btn-primary-md-blue"
                                            onClick={() => this.GetEmployeeGpsLogs(1)}
                                        >
                                            View GPS attendance
                  </Button>
                                    </div> */}
                </div>
                <div
                  style={{
                    marginTop: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 16,
                  }}
                >
                  <span
                    style={{
                      borderBottom: " solid 1px #ddd",
                      display: "block",
                      width: 12,
                    }}
                  ></span>
                  <span
                    className="normal-dark-secondary"
                    style={{ padding: "4px 8px" }}
                  >
                    Or
                  </span>
                  <span
                    style={{
                      borderBottom: " solid 1px #ddd",
                      display: "block",
                      width: 12,
                    }}
                  ></span>
                </div>

                <p className="small-dark-secondary margin-bottom-8">
                  Select group of employees
                </p>

                <DynamicForm
                  fields={selectinputconverter({
                    value: this.state.selectedofficelocationid,
                    options: this.state.officelocation,
                    placeholder: "Select location",
                    label: "Select office location",
                    disabled: this.state.employeeids,
                  })}
                  onChange={(id) =>
                    this.handleChange("selectedofficelocationid", id)
                  }
                />

                <div className="margin-top-8">
                  <p className="small-dark-secondary margin-bottom-8">
                    Advanced filters{" "}
                  </p>

                  <DynamicForm
                    fields={selectinputconverter({
                      value: this.state.selectedfilterid,
                      options: filterby,
                      placeholder: "Select filter by",
                      label: "Filter by",
                      disabled: this.state.employeeids,
                    })}
                    onChange={(id) => this.handleChange("selectedfilterid", id)}
                  />

                  {this.state.selectedfilterid && (
                    <DynamicForm
                      fields={selectinputconverter({
                        value:
                          this.state.selectedfilterid == 1
                            ? this.state.selectedshiftdata
                            : this.state.selectedfilterid == 2
                            ? this.state.selecteddepartmentid
                            : this.state.selectedfilterid == 3
                            ? this.state.selecteddesignationid
                            : null,
                        options:
                          this.state.selectedfilterid == 1
                            ? this.state.shifts
                            : this.state.selectedfilterid == 2
                            ? this.state.department
                            : this.state.selectedfilterid == 3
                            ? this.state.designation
                            : [],
                        placeholder:
                          this.state.selectedfilterid == 1
                            ? "Select shift"
                            : this.state.selectedfilterid == 2
                            ? "Select department"
                            : this.state.selectedfilterid == 3
                            ? "Select designation"
                            : "",
                        label:
                          this.state.selectedfilterid == 1
                            ? "Select shift"
                            : this.state.selectedfilterid == 2
                            ? "Select department"
                            : this.state.selectedfilterid == 3
                            ? "Select designation"
                            : "",
                        disabled: this.state.employeeids,
                      })}
                      onChange={(id) =>
                        this.handleChange(
                          this.state.selectedfilterid == 1
                            ? "selectedshiftdata"
                            : this.state.selectedfilterid == 2
                            ? "selecteddepartmentid"
                            : this.state.selectedfilterid == 3
                            ? "selecteddesignationid"
                            : "",
                          id,
                        )
                      }
                    />
                  )}
                  {/* <Grid
                    container
                    style={{ marginTop: 16 }}
                    className="activityDivider"
                  >
                    <hr className="dashedDivider" />
                  </Grid> */}
                  <div style={{ marginTop: 16, textAlign: "center" }}>
                    <Button
                      color="primary"
                      variant="contained"
                      className="btn btn-primary-md-blue"
                      onClick={() => this.GetEmployeeGpsLogs(2)}
                    >
                      View GPS attendance
                    </Button>
                  </div>
                  {/* <div style={{ width: 120 }}>
                                    <DynamicForm
                                        fields={selectinputconverter({
                                            value: this.state.selectedshiftdata,
                                            options: this.state.shifts,
                                            placeholder: "Select shift",
                                            label: "Shift",
                                        })}
                                        onChange={(id) => this.handleChange("selectedshiftdata", id)}
                                    />
                                </div>
                                <div style={{ marginLeft: 8, width: 120 }}>
                                    <DynamicForm
                                        fields={selectinputconverter({
                                            value: this.state.selecteddepartmentid,
                                            options: this.state.department,
                                            placeholder: "Select department",
                                            label: "Department",
                                        })}
                                        onChange={(id) => this.handleChange("selecteddepartmentid", id)}
                                    />
                                </div>
                                <div style={{ marginLeft: 8, width: 120 }}>
                                    <DynamicForm
                                        fields={selectinputconverter({
                                            value: this.state.selecteddesignationid,
                                            options: this.state.designation,
                                            placeholder: "Select designation",
                                            label: "Designation",
                                        })}
                                        onChange={(id) => this.handleChange("selecteddesignationid", id)}
                                    />
                                </div>
                             */}
                </div>
              </Paper>
            )}
            {this.state.isempgpslogs &&
              (this.state.iscalendarfiltercheck ||
                (this.state.empgpslogs &&
                  this.state.empgpslogs.length > 0)) && (
                <Paper
                  className="rounded-rectangle-paper padding16 thin-scroll"
                  style={{
                    // height: "65vh",
                    height: "calc(100vh - 350px)",
                    overflowY: "auto",
                  }}
                >
                  {this.state.loading == true ? (
                    this.showLoader()
                  ) : (
                    <>
                      {/* {this.state.empgpslogs && this.state.empgpslogs.length > 0 ?
                                            <> */}
                      {!this.state.isselectedemp ? (
                        <>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              this.setState({
                                isempgpslogs: false,
                                empgpslogs: [],
                                iscalendarfiltercheck: false,
                              })
                            }
                          >
                            <img src={backArrowBlue}></img>

                            <span className="small-blue margin-left-16">
                              Back to filter
                            </span>
                          </div>

                          <p className="extra-small-dark-secondary margin-top-24">
                            Employees on map
                          </p>
                          {this.state.empgpslogs.map((x) => (
                            <div
                              style={{
                                display: "flex",
                                marginTop: 16,
                                cursor: "pointer",
                                alignItems: "center",
                              }}
                              onClick={() =>
                                this.setState({
                                  selectedempdata: x,
                                  isselectedemp: true,
                                  lat: x.gpslogs && x.gpslogs[0].latitude,
                                  lng: x.gpslogs && x.gpslogs[0].longitude,
                                })
                              }
                            >
                              <ProfilePicture
                                src={getFormattedImageLink(x.imagepath)}
                                height="32"
                                classname="margin-right-16"
                              />

                              <span className="small-dark-secondary link-small">
                                {x.fullname}
                              </span>
                            </div>
                          ))}
                        </>
                      ) : (
                        <div>
                          <div
                            className="display-flex"
                            style={{
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={backArrow}
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                this.setState({
                                  isselectedemp: false,
                                  selectedempdata: null,
                                  lat:
                                    this.state.empgpslogs &&
                                    this.state.empgpslogs[0] &&
                                    this.state.empgpslogs[0].gpslogs &&
                                    this.state.empgpslogs[0].gpslogs[0] &&
                                    this.state.empgpslogs[0].gpslogs[0]
                                      .latitude,
                                  lng:
                                    this.state.empgpslogs &&
                                    this.state.empgpslogs[0] &&
                                    this.state.empgpslogs[0].gpslogs &&
                                    this.state.empgpslogs[0].gpslogs[0] &&
                                    this.state.empgpslogs[0].gpslogs[0]
                                      .longitude,
                                })
                              }
                            ></img>

                            <ProfilePicture
                              src={getFormattedImageLink(
                                this.state.selectedempdata.imagepath,
                              )}
                              height="32"
                              classname="margin-right-16 margin-left-16"
                            />

                            <span className="small-dark-secondary">
                              {this.state.selectedempdata.fullname}
                            </span>
                          </div>
                          <div style={{ marginTop: 16 }}>
                            {this.state.selectedempdata.gpslogs &&
                              this.state.selectedempdata.gpslogs.map((x) => (
                                <div style={{ marginBottom: 24 }}>
                                  <p className="normal-dark">
                                    {" "}
                                    {getUserFormattedTimeFromAPIData(
                                      x.punchtime,
                                    )}
                                  </p>

                                  <p className="small-dark-secondary margin-top-8">
                                    {x.punchlocation}
                                  </p>
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                      {this.state.iscalendarfiltercheck &&
                        this.state.empgpslogs &&
                        this.state.empgpslogs.length == 0 && (
                          <div className="position-rel">
                            <DefaultComp
                              subheading={
                                this.state.isdefault
                                  ? "Search employee by name or apply filter to see their GPS attendance"
                                  : "No record found"
                              }
                              imageSrc={blankstate}
                            />
                          </div>
                        )}
                      {/* </>
                                            :
                                            <>
                                                <div style={{ display: "flex", marginLeft: 8, marginTop: 16 }}>
                                                    <span
                                                        className="floatleft margin-right-16 cursor-pointer"
                                                        onClick={() =>
                                                            this.setState({
                                                                isempgpslogs: false,
                                                                empgpslogs: [],
                                                            })
                                                        }
                                                    >
                                                        <img src={backArrow}></img>
                                                        <span style={{ marginLeft: 8 }} className="extra-small-dark-secondary" >Back to filter</span>
                                                    </span>
                                                </div>
                                                <DefaultComp
                                                    subheading="Search employee by name or apply filter to see their GPS attendance"
                                                    imageSrc={blankstate}
                                                />
                                            </>
                                        } */}
                    </>
                  )}
                </Paper>
              )}
          </Grid>
          <Grid item md={8} sm={12} className="position-rel">
            <div
              className={this.state.loading ? "display-block" : "display-none"}
            >
              {this.showLoader()}
            </div>

            <div
              style={{ height: "calc(100vh - 158px)", width: "100%" }}
              className={
                !this.state.loading &&
                (!this.state.isempgpslogs ||
                  (this.state.isempgpslogs &&
                    this.state.empgpslogs.length == 0))
                  ? "gps"
                  : this.state.loading
                  ? "display-none"
                  : "display-block"
              }
            >
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: Configs.GPS_CONFIG.apiKey,
                }}
                defaultCenter={{
                  lat: 19.1181078,
                  lng: 72.850086,
                }}
                defaultZoom={11}
                center={{
                  lat: this.state.lat,
                  lng: this.state.lng,
                }}
                zoom={4}
                resetBoundsOnResize={true}
                // yesIWantToUseGoogleMapApiInternals={true}
                // onGoogleApiLoaded={({ map, maps }) => this.apiIsLoaded(map, maps, this.state.lat, this.state.lng)}
              >
                {this.state.isselectedemp == false
                  ? this.state.empgpslogs &&
                    this.state.empgpslogs.length > 0 &&
                    this.state.empgpslogs.map((x) => (
                      <Marker
                        latlang={null}
                        lat={x.gpslogs[0].latitude}
                        lng={x.gpslogs[0].longitude}
                        imagepath={x.imagepath}
                        name={x.fullname}
                        punchtime={x.gpslogs[0].punchtime}
                        color="#FF0000"
                      />
                    ))
                  : this.state.selectedempdata &&
                    this.state.selectedempdata.gpslogs.length > 0 &&
                    this.state.selectedempdata.gpslogs.map((x) => (
                      <Marker
                        lat={x.latitude}
                        lng={x.longitude}
                        imagepath={this.state.selectedempdata.imagepath}
                        name={this.state.selectedempdata.fullname}
                        punchtime={x.punchtime}
                        color="#FF0000"
                        // defaultAnimation={google.maps.Animation.DROP}
                      />
                    ))}
              </GoogleMapReact>
            </div>
            {this.state.loading == false &&
              (!this.state.isempgpslogs ||
                (this.state.isempgpslogs &&
                  this.state.empgpslogs.length == 0)) && (
                <div className="gpsdefault vertical-center">
                  <img
                    src={blankstate}
                    height="130"
                    style={{ marginBottom: 24 }}
                  ></img>
                  <p className="large-text-dark-secondary">
                    {this.state.isdefault
                      ? "Search employee by name or apply filter to see their GPS attendance"
                      : "No record found"}
                  </p>
                </div>
              )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

// const VerticalTabs = withStyles(() => ({
//     flexContainer: {
//         flexDirection: "column",
//     },
//     indicator: {
//         display: "none",
//     },
// }))(Tabs);

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      RightDrawer: (data) => RightDrawer(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(withSnackbar(Gps)));
